export const AUTH_CLIENT_KEY = "authClient";
export const USER_TYPE = "UserType";